<template>
  <section>
    <div class="user-main">
      <div class="utab clearfix">
        <ul class="clearlist clearfix fl">
          <li :class="status==''?'active':''" @click="changeTab('')">
            <a href="javascript:;">所有订单</a>
          </li>
          <li :class="status=='0'?'active':''" @click="changeTab('0')">
            <a href="javascript:;">待审核</a>
          </li>
          <li :class="status==1?'active':''" @click="changeTab('1')">
            <a href="javascript:;">已审核</a>
          </li>
          <li :class="status==2?'active':''" @click="changeTab('2')">
            <a href="javascript:;">审核失败</a>
          </li>
        </ul>
      </div>
      <div class="user-cont layui-card">
        <div class="layui-card-body">
          <div class="pingtai flex">
            <div class="wire"></div>
            <span>询价单</span>
          </div>
          <div class="cartcontent" v-for="(item,index) in xunjiaorder.data" :key="index">
            <el-table border :data="item.detail||[]" tooltip-effect="dark" style="width: 100%">
              <el-table-column prop label="订单信息" width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.orderno}}</span>
                  <br />
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="sn" label="编码"></el-table-column>
              <el-table-column prop="title" label="商品名字" width="300"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
              <el-table-column prop="unit" label="单位"></el-table-column>

              <el-table-column prop="amount3" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0">待审核</span>
                  <span v-if="scope.row.status==1">已审核</span>
                  <span v-if="scope.row.status==2">审核失败</span>
                  <!-- <el-button type="danger" size="small" @click="deleteorder(scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
         <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="xunjiaorder.per_page"
          @current-change="currentPagegoods"
          :total="xunjiaorder.total"
        ></el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Askorder",
  data() {
    return {
      status: "",
      page: 1,
      xunjiaorder: {data:[]},
    
    };
  },

  props: {},
  methods: {
    currentPagegoods(e){
      this.page=e;
      this.getOrderList();
    },
    changeTab(e) {
      this.status = e;
      console.log("this.status", this.status);
      this.getOrderList();
    },
    async getOrderList() {
      let res = await this.$fetch("member/orderquerylist", {
        body: {
          page: this.page,
          status: this.status
        }
      });
      if(res.data.length==0){
        res.data=[{detail:[]}]
      }
      this.xunjiaorder = res;
      console.log(res);
    }
  },
  async mounted() {
    this.getOrderList();
  }
};
</script>

<style lang='scss' scoped>
.cartcontent {
  margin-bottom: 20px;
}
.pingtai {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  .wire {
    width: 4px;
    height: 14px;
    background: rgba(241, 157, 21, 1);
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/askOrder.vue